import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEmployeeAuth } from '@/context/EmployeeAuthContext';

export default function EmployeeProtectedRoute() {
  const { employee, token, loading, refresh } = useEmployeeAuth();
  const location = useLocation();

  useEffect(() => {
    if (token && !employee && !loading) refresh();
  }, [token, employee, loading, refresh]);

  if (!token) {
    return <Navigate to="/portal/login" replace state={{ from: location }} />;
  }
  if (loading && !employee) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--brand-bg)]">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  return <Outlet />;
}
